import './AccessStatisticsRow.scss';

import classNames from 'classnames';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { hexToRgb } from '@lib/color';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SonarText } from '@ui/text';
import { Tag } from 'antd';
import { useNavigate } from 'react-router';
import { usePeriscopeActions } from '@hooks';

import React, { useCallback } from 'react';

const getBackgroundColor = (color?: string) => {
	if (!color) {
		return;
	}

	const { r, g, b } = hexToRgb(color);

	return `rgba(${r},${g},${b}, .3)`;
};

export interface AccessStatisticsRowProps {
	className?: string;
	clickable?: boolean;
	color?: string;
	colorName?: string;
	count: number;
	extra?: React.ReactNode;
	id: number;
	max: number;
	name: string;
	type?: SonarObjectType;
}

export const AccessStatisticsRow : React.FC<AccessStatisticsRowProps> = ({
	className,
	clickable = true,
	color,
	colorName,
	count,
	extra,
	id,
	max,
	name,
	type
}) => {
	const { openPeriscope } = usePeriscopeActions();
	const navigate = useNavigate();
	const overflow = count / max < 0.2;

	const handleOpenPeriscope = useCallback(() => {
		if (type) {
			openPeriscope({
				id,
				name,
				openedFromIndex: -1,
				type
			});
		} else {
			navigate(`${FULL_ROUTES.DATA_SECURITY}/${id}`);
		}
	}, [ id, name, navigate, openPeriscope, type ]);

	return (
		<div
			className={ classNames('access-statistics-row', className, { clickable }) }
			onClick={ clickable ? handleOpenPeriscope : undefined }>
			<div className='name-bar'>
				<Tag
					className={ classNames('color-bar', colorName) }
					color={ colorName }
					style={ {
						backgroundColor: getBackgroundColor(color),
						borderColor: color,
						width: `${(count / max) * 100}%`
					} } />
				<div className={ classNames('stat-details', { overflow }) }>
					<SonarText>{ name }</SonarText>
					<div>{ extra }</div>
				</div>
			</div>
			<div className='request-count'>
				<SonarText>{ count.toLocaleString() }</SonarText>
			</div>
		</div>
	);
};
